export const GET_CONFIG = 'NOTIFICATIONS_GET_CONFIG'
export const SET_CONFIG = 'NOTIFICATIONS_SET_CONFIG'

export const GET_RESTRICTIONS = 'GET_RESTRICTIONS'
export const SET_RESTRICTIONS = 'SET_RESTRICTIONS'

export const CLEAR_NOTIFICATION_ERROR = 'CLEAR_NOTIFICATION_ERROR'
export const SET_NOTIFICATION_ERROR = 'SET_NOTIFICATION_ERROR'
export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION'
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'
export const GET_NOTIFICATION = 'GET_NOTIFICATION'
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS'
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'

export const CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION'
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION'
export const REMOVE_SUBSCRIPTION = 'REMOVE_SUBSCRIPTION'
export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS'
export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS'
export const GET_SUBSCRIPTION = 'GET_SUBSCRIPTION'
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION'

export function setError (err) {
  return {
    type: SET_NOTIFICATION_ERROR,
    payload: { err },
  }
}

export function clearError () {
  return {
    type: CLEAR_NOTIFICATION_ERROR,
    payload: {},
  }
}

export function getConfig (err) {
  return {
    type: GET_CONFIG,
    payload: { err },
  }
}

export function setConfig (data) {
  return {
    type: SET_CONFIG,
    payload: data,
  }
}

export function getRestrictions (contentId) {
  return {
    type: GET_RESTRICTIONS,
    payload: { contentId },
  }
}

export function setRestrictions (contentId, restrictions) {
  return {
    type: SET_RESTRICTIONS,
    payload: { contentId, restrictions },
  }
}

export function createSubscription (attributes, filter) {
  return {
    type: CREATE_SUBSCRIPTION,
    payload: { attributes, type: filter },
  }
}

export function removeSubscription (id, filter) {
  return {
    type: REMOVE_SUBSCRIPTION,
    payload: { id, type: filter },
  }
}

export function updateSubscription (attributes, filter) {
  return {
    type: UPDATE_SUBSCRIPTION,
    payload: { attributes, type: filter },
  }
}

export function getSubscription (id) {
  return {
    type: GET_SUBSCRIPTION,
    payload: { id },
  }
}

export function setSubscription (data) {
  return {
    type: SET_SUBSCRIPTION,
    payload: { data },
  }
}

export function getSubscriptions (options) {
  return {
    type: GET_SUBSCRIPTIONS,
    payload: options,
  }
}

export function setSubscriptions (data) {
  return {
    type: SET_SUBSCRIPTIONS,
    payload: { data },
  }
}

export function createNotification (attributes, filter) {
  return {
    type: CREATE_NOTIFICATION,
    payload: { attributes, type: filter },
  }
}

export function removeNotification (id, filter) {
  return {
    type: REMOVE_NOTIFICATION,
    payload: { id, type: filter },
  }
}

export function updateNotification (attributes, filter) {
  return {
    type: UPDATE_NOTIFICATION,
    payload: { attributes, type: filter },
  }
}

export function getNotification (id) {
  return {
    type: GET_NOTIFICATION,
    payload: { id },
  }
}

export function setNotification (data) {
  return {
    type: SET_NOTIFICATION,
    payload: { data },
  }
}

export function getNotifications (options) {
  return {
    type: GET_NOTIFICATIONS,
    payload: options,
  }
}

export function setNotifications (data) {
  return {
    type: SET_NOTIFICATIONS,
    payload: { data },
  }
}
